import React from 'react';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';
import { P } from 'sushiweb/Typography/Text';
import {
  SampleDataInstruction,
  sampleEmployeeColumns,
  sampleEmployeeGroupsColumns,
  sampleEmployeeData,
  sampleTableStyle,
} from '../constants';
import {
  SampleEmployeeContainer,
  SampleDataContainer,
  InstructionLabel,
} from '../styles';

export const SampleEmployeeTable = ({ group }) => {
  return (
    <SampleEmployeeContainer>
      <P>Sample employee record</P>
      <SampleDataContainer group={group}>
        <DataTable
          columns={group ? sampleEmployeeGroupsColumns : sampleEmployeeColumns}
          data={sampleEmployeeData}
          customStyles={sampleTableStyle}
        />
      </SampleDataContainer>
      <InstructionLabel>{SampleDataInstruction}</InstructionLabel>
    </SampleEmployeeContainer>
  );
};

SampleEmployeeTable.propTypes = {
  group: PropTypes.bool,
};

SampleEmployeeTable.defaultProps = {
  group: false,
};

export default SampleEmployeeTable;
